<template>
  <div>
    <post-evidence-card
      :part="post.part"
      :post="post"
      :order="1"
      :editable="editable"
      :submittable="submittable"
      :assessable="assessable"
      :disabled="disabled"
      :evidence-submission="evidenceSubmission"
      class="observable"
      :mode="mode"
      :evidence-submitting="evidenceSubmitting"
      :readonly="readonly"
      :allow-assess="allowAssess"
      :hide-comment="hideComment"
      :hide-delete="hasUserEnrolled"
      @save-success="$emit('save-success', $event)"
      @processing="$emit('processing', $event)"
    >
    </post-evidence-card>
  </div>
</template>

<script>
import PostEvidenceCard from './PostEvidenceCard.vue';
export default {
  components: {
    PostEvidenceCard
  },
  props: {
    post: {
      type: Object,
      required: true
    },

    editable: {
      type: Boolean,
      default: false
    },
    submittable: {
      type: Boolean,
      default: false
    },
    assessable: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    evidenceSubmission: {
      type: Object,
      required: true
    },
    mode: {
      type: String,
      default: ''
    },
    evidenceSubmitting: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    allowAssess: {
      type: Boolean,
      default: false
    },
    hideComment: {
      type: Boolean,
      default: false
    },
    hasUserEnrolled: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss" scoped></style>
